import Vue from "vue"
import { AclInstaller, AclCreate, AclRule } from "vue-acl"
import router from "@/router"
import axios from "@/axios.js"
import store from '@/store/store'

Vue.use(AclInstaller)

let initialRole = "Public"

let userInfo = JSON.parse(localStorage.getItem("userInfo"))
// if(userInfo && userInfo.userRole) initialRole = userInfo.userRole
if (userInfo && userInfo.userRole) {
  initialRole = parseJwt(localStorage.getItem("accessToken")).role;
  if (initialRole == 'Consumer')
    initialRole = ['Consumer', 'OnlyConsumer'];
  else if (Array.isArray(initialRole)
    && initialRole.find(x => x == 'Consumer')
    && !initialRole.find(x => x == 'Merchant')
  ) {
    initialRole.push('OnlyConsumer')
  }
}

let globalRules = generateRules();
export default new AclCreate({
  initial: initialRole,
  notfound: "/pages/login",
  router,
  acceptLocalRules: true,
  globalRules: globalRules
});

function parseJwt(token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
};
function generateRules() {
  let globalRules =
  {
    'isAdmin': new AclRule("Admin").generate(),
    'isPromoter': new AclRule("Promoter").generate(),
    'isOperator': new AclRule("Operator").generate(),
    'isSupport': new AclRule("Support").generate(),
    'isMerchant': new AclRule("Merchant").generate(),
    'mo': new AclRule("Merchant").or("Operator").generate(),
    'mc': new AclRule("Merchant").or("Consumer").generate(),
    'oa': new AclRule("Admin").or("Operator").generate(),
    'asm': new AclRule("Admin").or("Merchant").or("Support").generate(),
    'onlyConsumer': new AclRule("OnlyConsumer").generate(),
    'isConsumer': new AclRule("Consumer").generate(),
    'isPublic': new AclRule("Operator").or("Admin").or("Merchant").or("Consumer").or('Public').or('Promoter').generate()
  };

  let firstRole = Array.isArray(initialRole) ? initialRole[0] : initialRole;
  let permissions = store.getters["permission/items"];
  permissions.forEach((x) => {
    //console.log(x);
    globalRules[x] = new AclRule(firstRole).generate();
    //console.log(x);
  });
  return globalRules;
}